module.exports = __webpack_public_path__ + "static/media/canvas_measure.d5df5a62.svg";